import { render } from "./AddTransaction.vue?vue&type=template&id=d7cf16f4&ts=true"
import script from "./AddTransaction.vue?vue&type=script&lang=ts"
export * from "./AddTransaction.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__